import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { getIAPStore } from './get-iap-store';
import { LoadingButton } from '@mui/lab';
import { Alert, AlertTitle } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useMutationCallback } from 'shared/api/hooks';
export const IAPPayButton = memo(function IAPPayButton(props) {
    const { product_id, title, variant = 'contained' } = props;
    const store = useMemo(() => getIAPStore(), []);
    const [loading, noLoading, setLoading] = useBooleanState(false);
    const [isSuccess, noSuccess, setSuccess] = useBooleanState(false);
    const [message, setMessage] = useState(null);
    const [run] = useMutationCallback('verified_purchase');
    const onClick = useCallback(async () => {
        setLoading();
        if (store) {
            const product = store.get(product_id);
            if (!product) {
                console.error('Product not found');
                setMessage('Не удалось совершить покупку');
                noLoading();
                return;
            }
            // console.log('product', JSON.stringify(product));
            const offer = product.getOffer();
            if (!offer) {
                console.error('Offer not found');
                setMessage('Не удалось совершить покупку 2');
                noLoading();
                return;
            }
            // console.log('offer', JSON.stringify(offer));
            try {
                const result_error = await offer.order();
                console.log('result_error', JSON.stringify(result_error));
                if (result_error) {
                    if (result_error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                        noSuccess();
                        setMessage('Покупка отменена');
                        noLoading();
                    }
                    else {
                        noSuccess();
                        setMessage('Ошибка обработки транзакции');
                        noLoading();
                        console.error('Error processing transaction', result_error);
                    }
                }
                else {
                    run({
                        product_type: offer.productType,
                        product_id,
                        owned: product.owned,
                    });
                    setSuccess();
                    setMessage('Покупка совершена');
                    noLoading();
                }
            }
            catch (error) {
                if (error) {
                    if (error.code === CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                        noSuccess();
                        setMessage('Покупка отменена');
                        noLoading();
                    }
                    else {
                        noSuccess();
                        setMessage('Ошибка обработки транзакции');
                        noLoading();
                        console.error('Error processing transaction', error);
                    }
                }
            }
        }
        else {
            noLoading();
            setMessage('Не удалось инициализировать покупку');
        }
    }, [store, product_id]);
    const onClose = useCallback(() => setMessage(null), []);
    return (_jsxs(_Fragment, { children: [_jsx(LoadingButton, { loading: loading, onClick: onClick, color: "primary", variant: variant, children: title }), _jsx(MessageBox, { open: message != null, onClose: onClose, title: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438", maxWidth: "xs", isSuccess: isSuccess, isError: !isSuccess, closeButtonTitle: "\u041E\u043A", children: _jsx(Alert, { severity: isSuccess ? 'success' : 'error', children: _jsx(AlertTitle, { children: message }) }) })] }));
});
